/**
 * ObjectPasswordField React component
 * 
 * @author    Maurizio Tidei, Jens Gruschel
 * @copyright © 2019 contexagon GmbH
 */


// React
import React from 'react';
import PropTypes from 'prop-types';

// Material UI
import {withStyles} from "@material-ui/core";

// Material UI components
import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';

// icons
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';


/**
 * ObjectPasswordField is an editing component for passwords of objects
 *
 * @author Maurizio Tidei, Jens Gruschel
 */
export class ObjectPasswordField extends React.Component {

    state = {
        showPassword: false
    };

    handleChange = id => event => {
        const value = event.target.value === "" ? undefined : event.target.value;
        this.props.onObjectValueChange(id, value);
    };

    render() {

        const { classes, fieldDef } = this.props;

        return <FormControl fullWidth={true} className={classes.passwordFormControl}>
            <InputLabel htmlFor="adornment-password">{fieldDef.name}</InputLabel>
            <Input
                id="adornment-password"
                type={this.state.showPassword ? 'text' : 'password'}
                value={this.props.value}
                disabled={this.props.readOnly}
                onChange={this.handleChange(fieldDef.id, false)}
                endAdornment={
                    <InputAdornment position="end">
                        <IconButton
                            aria-label="Toggle password visibility"
                            onClick={() => this.setState(state => ({showPassword: !state.showPassword}))}
                        >
                            {this.state.showPassword ? <Visibility/> : <VisibilityOff/>}
                        </IconButton>
                    </InputAdornment>
                }
            />
        </FormControl>;
    }
}

ObjectPasswordField.propTypes = {
    onObjectValueChange: PropTypes.func.isRequired,
    fieldDef: PropTypes.object.isRequired,
    objectId: PropTypes.string,
    readOnly: PropTypes.bool,
    value: PropTypes.any
};

const styles = {
    passwordFormControl: {
        marginTop: 16,
        marginBottom: 8
    }
};

export default withStyles(styles)(ObjectPasswordField);